import { DUPLICATE_SUBSCRIPTION_ERROR_CODE } from '@/constants/chargebee';
import type { ApiError } from '@/services/apiClient';

/**
 * Ported from independent-checkout-v2 `utils/subscription-errors.ts`, adapted
 * from axios (`error.response.data.errorCode`) to v3's `ApiError` (parsed
 * body on `error.info`).
 */
export const isDuplicateSubscriptionError = (error: unknown): boolean => {
  return getSubscriptionErrorCode(error) === DUPLICATE_SUBSCRIPTION_ERROR_CODE;
};

const getSubscriptionErrorCode = (error: unknown): string | undefined => {
  const info = (error as ApiError)?.info;
  if (!info || typeof info !== 'object') return undefined;
  const { errorCode } = info as { errorCode?: unknown };
  return typeof errorCode === 'string' ? errorCode : undefined;
};
